export const routes = {
  Root: "/",
  SignIn: "/sign-in",
  Systems: "/systems",
  Files: "/files",
  Jobs: "/jobs",
  JobDetails: "/jobs/:jobId",
  Admin: "/admin",
  Settings: "/settings",
  Comment: "/comment",
  FunctionAuthCallback: "/callback",
  NotFound: "/404",
  Documentation: "/documentation",
  MagicDocs: "/magic-docs",
  Upload: "/upload",
  AdminUsers: "/admin/users",
  AdminFunctions: "/admin/functions",
  AdminControlTags: "/admin/control-tags",
  Agents: "/agents",
  AdminAppIntegrations: "/admin/app-integrations",
  AdminIntegrations: "/admin/integrations",
  AdminPublicCredsCryptoKey: "/admin/public-key",
  AdminEncryption: "/admin/encryption",
  AdminInfosecLevels: "/admin/infosec-levels",
  AdminInfosec: "/admin/infosec",
  AdminUsage: "/admin/usage",
  SystemDetails: "/systems/:systemId?/:configId?/:snapshotId?/tree?/*",
  Artifact: "/artifact/:artifactId/:artifactVersionId?",
  CommentDetails: "/comment/:commentId",
} as const;

export type RouteKeys = keyof typeof routes;
export type RouteValues = (typeof routes)[keyof typeof routes];
